import axios from "axios";

export const ATTENDANCE_URL = "/Attendance";

/** Mevcut Okulun Mevcut Dönemdeki Aktif Öğretmen Listesi ve Günlük Ders Saatini Elde Eder */
export function getTeachersAndDailyCourseHour() {
  return axios.get(ATTENDANCE_URL);
}

/** Mevcut Okulun Belli Bir Sınıf Listesine Ait Yoklama Raporunu Elde Eder */
export function getSectionAttendances(queryParams) {
  return axios.post(`${ATTENDANCE_URL}/GetSectionAttendances`, queryParams);
}

/** Mevcut Okulun Belli Bir Sınıf Listesine Ait Yoklama Raporunu Sayfalama Olmadan Elde Eder */
export function getAllSectionAttendances(queryParams) {
  return axios.post(`${ATTENDANCE_URL}/GetAllSectionAttendances`, queryParams);
}

/** Mevcut Okulun Belli Bir Sınıf Yoklamasının Detaylarını Elde Eder */
export function getAttendanceDetails(sectionId, date, courseHour) {
  return axios.get(`${ATTENDANCE_URL}/GetAttendanceDetails/${sectionId}/${date}/${courseHour}`);
}

/** Mevcut Okulun Mevcut Dönemindeki Belli Bir Sınıfının Belli Bir Öğrenci Listesini Elde Eder */
export function getStudents(queryParams) {
  return axios.post(`${ATTENDANCE_URL}/GetStudents`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemindeki Belli Bir Sınıfının Belli Bir Öğrenci Listesini Sayfalama Olmadan Elde Eder */
export function getAllStudents(queryParams) {
  return axios.post(`${ATTENDANCE_URL}/GetAllStudents`, queryParams);
}

/** Mevcut Okulun Aktif Sınıf Listesini Elde Eder */
export function getSections() {
  return axios.get(`${ATTENDANCE_URL}/GetSections`);
}

/** Mevcut Okulun Mevcut Dönemindeki Belli Bir Şubesinin Belli Bir Öğrenci Listesine Ait Öğrenci Devamsızlıklarını Elde Eder */
export function getStudentAbsenteeisms(queryParams) {
  return axios.post(`${ATTENDANCE_URL}/GetStudentAbsenteeisms`, queryParams);
}

/** Belli Bir Öğrenci Listesinin Devamsızlıklarını Kaydeder */
export function saveAbsenteeisms(datas) {
  return axios.post(ATTENDANCE_URL, { datas });
}

/** Belli Bir Sınıf Yoklamasını Siler */
export function deleteAttendance(data) {
  return axios.post(`${ATTENDANCE_URL}/SectionAttendanceDelete`, { data });
}

/** Belli Bir Öğrenci Yoklaması Listesini Siler */
export function deleteAttendances(ids) {
  return axios.post(`${ATTENDANCE_URL}/Delete`, ids);
}